import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import "./assets/js/nav-pills.js";
import "./assets/scss/argon-dashboard.scss";

export default {
  install() {},
};
